import { Card, Spin, notification, Select } from "antd";
import React from "react";
import {
  ChannelContext,
  ChannelContextProvider,
  ChannelContextType,
} from "../../contexts/channels/ChannelContext";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ChannelModel } from "../../models/ChannelModel";
import "./channel.css";
import {
  DonationSingleCartResultInterface,
  DonationSingleResultInterface,
} from "../../contexts/payment/interfaces/donation-single-result.interface";
import {
  PaymentContext,
  PaymentContextProvider,
  PaymentContextType,
} from "../../contexts/payment/PaymentContext";
// import { NotificationPlacement } from "antd/lib/notification";
import { Typography } from 'antd'
import { NotificationPlacement } from "antd/lib/notification";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import { DownOutlined } from "@ant-design/icons";
import { getPaymentImageUrl } from "../../helpers/payment-scope.helper";
import { cleanUserData, trackCapiAndPixel } from "../../helpers/capi.helper";
export interface PaymentInterfaceParam {
  item: ChannelModel;
  encrypt?: string;
  donationResult?: DonationSingleResultInterface;
  donationCartResult?: DonationSingleCartResultInterface;
}

function Channel() {
  return (
    <ChannelContextProvider>
      <PaymentContextProvider>
        <ChannelState />
      </PaymentContextProvider>
    </ChannelContextProvider>
  );
}

function ChannelState() {
  const {
    channels,
    midtransChannels,
    ipaymuChannels,
    walletChannels,
    nicepayChannels,
    ifortepayChannels,
    ryFlipChannels,
    ryFlipWalletChannels,
    plinkChannels,
    getPaymentChannels,
  } = React.useContext(ChannelContext) as ChannelContextType;
  const [encrypt, setEncrypt] = React.useState<string>("");
  const [donationResult, setDonationResult] =
    React.useState<DonationSingleResultInterface>(undefined);
  const { getDonationDetailCart, donationDetailCart, donationDetailLoading } =
    React.useContext(PaymentContext) as PaymentContextType;
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const trackedInitiateCheckoutRef = React.useRef(false);
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement: NotificationPlacement) => {
    api.error({
      message: `Gagal`,
      description: "Anda harus login untuk menggunakan fitur wallet",
      placement,
    });
  };
  const openNotificationTemp = (placement: NotificationPlacement) => {
    api.error({
      message: `Mohon Maaf`,
      description:
        "Untuk keranjang donasi yang lebih dari 1, silahkan gunakan metode pembayaran lain, untuk sementara metode pembayaran Transfer Manual belum bisa digunakan untuk keranjang donasi lebih dari 1.",
      placement,
    });
  };

  React.useEffect(() => {
    if (params) {
      if (params["invoice_code"] !== undefined) {
        getDonationDetailCart(params["invoice_code"] as string);
      }
    }
  }, [params]);

  React.useEffect(() => {
    if (encrypt !== "") {
      getDonationDetailCart(encrypt);
    }
  }, [encrypt]);

  React.useEffect(() => {
    setEncrypt(location.search.replace("?token=", ""));
  }, [location]);

  React.useEffect(() => {
    if (
      donationDetailCart &&
      donationDetailCart.data &&
      donationDetailCart.data.length > 0
    ) {
      const firstItem = donationDetailCart.data[0];
      const programId = firstItem.program_id || firstItem.program?.id;
      const programCategoryId =
        firstItem.program?.program_category_id ||
        firstItem.program?.program_category?.id;
      const companyId =
        firstItem.company_id || process.env.REACT_APP_COMPANY_ID;

      if (programId || programCategoryId || companyId) {
        getPaymentChannels({
          programId,
          programCategoryId,
          companyId,
        });
      }
    }
  }, [donationDetailCart]);

  React.useEffect(() => {
    if (
      donationDetailCart &&
      donationDetailCart.data &&
      donationDetailCart.data.length > 0 &&
      !trackedInitiateCheckoutRef.current
    ) {
      trackedInitiateCheckoutRef.current = true;
      const firstItem = donationDetailCart.data[0];
      const invoiceCode =
        firstItem.invoice_code ||
        firstItem.order_id ||
        (params as Record<string, string>)?.invoice_code;
      const totalAmount = donationDetailCart.data.reduce(
        (sum, item) => sum + (item.amount || 0),
        0
      );
      const customItem = firstItem as unknown as {
        donor_email?: string;
        donor_phone_number?: string;
        donor_name?: string;
      };
      const email = firstItem.customer_email || customItem.donor_email;
      const phone = firstItem.customer_phone || customItem.donor_phone_number;
      const name = firstItem.customer_name || customItem.donor_name;
      const programName =
        firstItem.program?.title || firstItem.program_name || "Donation";

      if (invoiceCode) {
        trackCapiAndPixel({
          eventName: "InitiateCheckout",
          eventId: `init_${invoiceCode}`,
          userData: cleanUserData(email, phone, name),
          customData: {
            currency: "IDR",
            value: totalAmount,
            order_id: invoiceCode,
            content_name: programName,
            content_type: "product",
          },
          companyId: firstItem.company_id || process.env.REACT_APP_COMPANY_ID,
        });
      }
    }
  }, [donationDetailCart, params]);

  React.useEffect(() => {
    if (donationDetailCart) {
      if (donationDetailCart.data.length > 0) {
        if (donationDetailCart.data[0].status === "settlement") {
          axios
            .get(
              `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
            )
            .then((res) => {
              const response = res.data as CompanySingleResultInterface;
              console.log(response);
              const url = `${response?.data?.platform_donation}/payment/success?order_id=${donationDetailCart?.data[0].invoice_code}&result=success`;
              window.location.href = url;
            });
        }
      }
    }
  }, [donationDetailCart])

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      {contextHolder}
      <Spin tip="Loading..." spinning={donationDetailLoading}>
        {midtransChannels?.length > 0 && <Typography.Title level={3}>Midtrans VA & Merchants</Typography.Title>}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {midtransChannels.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 5,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white'
                }}
                onClick={(e) => {
                  e.preventDefault();

                  const donationDetailSingle: DonationSingleResultInterface = {
                    status: donationDetailCart?.status,
                    message: donationDetailCart.message,
                    data: donationDetailCart.data[0],
                    error: donationDetailCart.error,
                  };

                  let param: PaymentInterfaceParam = {
                    item: item,
                    donationResult: donationDetailSingle,
                    donationCartResult: donationDetailCart,
                  };

                  if (donationDetailCart.data?.length > 1) {
                    history.push({
                      pathname: "/payment-midtrans-cart",
                      state: param,
                    });
                  } else {
                    history.push({
                      pathname: "/payment-midtrans",
                      state: param,
                    });
                  }
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.title}</span>
                </div>
              </button>
            );
          })}
        </div>

        {ipaymuChannels?.length > 0 && <h3>i-Paymu VA & Merchants</h3>}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {ipaymuChannels.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 5,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white'
                }}
                onClick={(e) => {
                  e.preventDefault();

                  const donationDetailSingle: DonationSingleResultInterface = {
                    status: donationDetailCart?.status,
                    message: donationDetailCart.message,
                    data: donationDetailCart.data[0],
                    error: donationDetailCart.error,
                  };

                  let param: PaymentInterfaceParam = {
                    item: item,
                    donationResult: donationDetailSingle,
                    donationCartResult: donationDetailCart,
                  };

                  if (donationDetailCart.data?.length > 1) {
                    history.push({
                      pathname: "/payment-ipaymu-cart",
                      state: param,
                    });
                  } else {
                    history.push({
                      pathname: "/payment-ipaymu",
                      state: param,
                    });
                  }
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.title}</span>
                </div>
                {/* <Card.Meta
                // avatar={<img src={`/assets/${item.code}.png`} style={{ width: 40, height: 10, objectFit: 'contain' }}/>}
                avatar={<span className={`${item.thumbnail}`}></span>}
                title={item.title}
                description={item.subtitle}
              /> */}
              </button>
            );
          })}
        </div>

        {nicepayChannels?.length > 0 && <h3>NICEPAY VA & Merchants</h3>}
        {nicepayChannels.map((item, index) => {
          return (
            <Card
              key={index}
              style={{
                marginBottom: 10,
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();

                const donationDetailSingle: DonationSingleResultInterface = {
                  status: donationDetailCart?.status,
                  message: donationDetailCart.message,
                  data: donationDetailCart.data[0],
                  error: donationDetailCart.error,
                };

                let param: PaymentInterfaceParam = {
                  item: item,
                  donationResult: donationDetailSingle,
                  donationCartResult: donationDetailCart,
                };

                if (donationDetailCart.data?.length > 1) {
                  history.push({
                    pathname: "/payment-nicepay-cart",
                    state: param,
                  });
                } else {
                  history.push({
                    pathname: "/payment-nicepay",
                    state: param,
                  });
                }
              }}
            >
              <Card.Meta
                // avatar={<img src={`/assets/${item.code}.png`} style={{ width: 40, height: 10, objectFit: 'contain' }}/>}
                avatar={
                  <img
                    src={
                      getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                      `https://rustic.universa.vip/images/${item.thumbnail}`
                    }
                    alt={item.title}
                    style={{
                      width: 40,
                      maxHeight: 40,
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      if (
                        item.thumbnail &&
                        !target.src.includes(
                          `rustic.universa.vip/images/${item.thumbnail}`
                        )
                      ) {
                        target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                      }
                    }}
                  />
                }
                title={item.title}
                description={item.subtitle}
              />
            </Card>
          );
        })}

        {ifortepayChannels?.length > 0 && <h3>iFortePay</h3>}
        {ifortepayChannels.map((item, index) => {
          return (
            <Card
              key={index}
              style={{
                marginBottom: 10,
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault();

                const donationDetailSingle: DonationSingleResultInterface = {
                  status: donationDetailCart?.status,
                  message: donationDetailCart.message,
                  data: donationDetailCart.data[0],
                  error: donationDetailCart.error,
                };

                let param: PaymentInterfaceParam = {
                  item: item,
                  donationResult: donationDetailSingle,
                  donationCartResult: donationDetailCart,
                };

                if (donationDetailCart.data?.length > 1) {
                  history.push({
                    pathname: "/payment-ifortepay-cart",
                    state: param,
                  });
                } else {
                  history.push({
                    pathname: `/payment-ifortepay`,
                    state: param,
                  });
                }
              }}
            >
              <Card.Meta
                // avatar={<img src={`/assets/${item.code}.png`} style={{ width: 40, height: 10, objectFit: 'contain' }}/>}
                avatar={
                  <img
                    src={
                      getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                      `https://rustic.universa.vip/images/${item.thumbnail}`
                    }
                    alt={item.title}
                    style={{
                      width: 40,
                      maxHeight: 40,
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      if (
                        item.thumbnail &&
                        !target.src.includes(
                          `rustic.universa.vip/images/${item.thumbnail}`
                        )
                      ) {
                        target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                      }
                    }}
                  />
                }
                title={item.title}
                description={item.subtitle}
              />
            </Card>
          );
        })}

        {ryFlipChannels?.length > 0 && <Typography.Title level={3}>Virtual Accounts</Typography.Title>}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {ryFlipChannels.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 10,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white',
                }}
                onClick={(e) => {
                  e.preventDefault();

                  const donationDetailSingle: DonationSingleResultInterface = {
                    status: donationDetailCart?.status,
                    message: donationDetailCart.message,
                    data: donationDetailCart.data[0],
                    error: donationDetailCart.error,
                  };

                  let param: PaymentInterfaceParam = {
                    item: item,
                    donationResult: donationDetailSingle,
                    donationCartResult: donationDetailCart,
                  };

                  // if (donationDetailCart.data?.length > 1) {
                  //   history.push({
                  //     pathname: "/payment-ifortepay-cart",
                  //     state: param,
                  //   });
                  // } else {
                  //   history.push({
                  //     pathname: `/payment-ry-flip`,
                  //     state: param,
                  //   });
                  // }

                  history.push({
                    pathname: `/payment-ry-flip`,
                    state: param,
                  });
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    {/* <span className={`${item.thumbnail}`}></span> */}
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.subtitle}</span>
                </div>
                {/* <Card.Meta
                avatar={<span className={`${item.thumbnail}`}></span>}
                title={item.subtitle}
                description={item.subtitle}
              /> */}
              </button>
            );
          })}
        </div>

        {ryFlipWalletChannels?.length > 0 && <Typography.Title level={3} style={{ marginTop: 5 }}>Instant</Typography.Title>}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {ryFlipWalletChannels.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 5,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white'
                }}
                onClick={(e) => {
                  e.preventDefault();

                  const donationDetailSingle: DonationSingleResultInterface = {
                    status: donationDetailCart?.status,
                    message: donationDetailCart.message,
                    data: donationDetailCart.data[0],
                    error: donationDetailCart.error,
                  };

                  let param: PaymentInterfaceParam = {
                    item: item,
                    donationResult: donationDetailSingle,
                    donationCartResult: donationDetailCart,
                  };

                  // if (donationDetailCart.data?.length > 1) {
                  //   history.push({
                  //     pathname: "/payment-ifortepay-cart",
                  //     state: param,
                  //   });
                  // } else {
                  //   history.push({
                  //     pathname: `/payment-ry-flip`,
                  //     state: param,
                  //   });
                  // }

                  history.push({
                    pathname: `/payment-ry-flip`,
                    state: param,
                  });
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.subtitle}</span>
                </div>
                {/* <Card.Meta
                avatar={<span className={`${item.thumbnail}`}></span>}
                title={item.subtitle}
                description={item.subtitle}
              /> */}
              </button>
            );
          })}
        </div>

        {plinkChannels?.length > 0 && <Typography.Title level={3} style={{ marginTop: 5 }}>Prisma Link</Typography.Title>}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {plinkChannels.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 10,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white',
                }}
                onClick={(e) => {
                  e.preventDefault();

                  const donationDetailSingle: DonationSingleResultInterface = {
                    status: donationDetailCart?.status,
                    message: donationDetailCart.message,
                    data: donationDetailCart.data[0],
                    error: donationDetailCart.error,
                  };

                  let param: PaymentInterfaceParam = {
                    item: item,
                    donationResult: donationDetailSingle,
                    donationCartResult: donationDetailCart,
                  };

                  history.push({
                    pathname: `/payment-plink`,
                    state: param,
                  });
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.subtitle}</span>
                </div>
              </button>
            );
          })}
        </div>

        {channels?.length > 0 ? (
          <div style={{ marginTop: 25, marginBottom: 20 }}>
            <Typography.Title level={3} style={{ marginBottom: 15 }}>Transfer Manual</Typography.Title>
            <Select
              showSearch
              placeholder="Pilih Bank Transfer Manual"
              optionFilterProp="children"
              style={{
                width: '100%',
                height: 70,
              }}
              dropdownStyle={{
                borderRadius: 12,
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                padding: 8
              }}
              className="premium-select"
              suffixIcon={<DownOutlined style={{ fontSize: 14, color: '#94a3b8' }} />}
              onChange={(value) => {
                const item = channels.find(
                  (c) => c.id === value || c.code === value
                );
                if (!item) return;

                const donationDetailSingle: DonationSingleResultInterface = {
                  status: donationDetailCart?.status,
                  message: donationDetailCart?.message,
                  data: donationDetailCart?.data[0],
                  error: donationDetailCart?.error,
                };

                let param: PaymentInterfaceParam = {
                  item: item,
                  donationResult: donationDetailSingle,
                  donationCartResult: donationDetailCart,
                };

                if (donationDetailCart?.data?.length > 1) {
                  openNotificationTemp("topRight");
                } else {
                  history.push({
                    pathname: "/payment",
                    state: param,
                  });
                }
              }}
              optionLabelProp="label"
              filterOption={(input, option) =>
                (option?.label as unknown as string ?? '').toLowerCase().includes(input.toLowerCase())
              }
            >
              {channels.map((item) => (
                <Select.Option
                  key={item.id || item.code}
                  value={item.id || item.code}
                  label={item.title}
                >
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '8px 12px',
                    borderRadius: 8,
                    transition: 'all 0.3s ease'
                  }}>
                    <div style={{
                      width: 45,
                      height: 45,
                      marginRight: 16,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#f8f9fa',
                      borderRadius: 10,
                      border: '1px solid #eee',
                      overflow: 'hidden',
                    }}>
                      {(() => {
                        const imageUrl = getPaymentImageUrl(item.image_payment);
                        if (imageUrl) {
                          return (
                            <>
                              <img
                                src={imageUrl}
                                alt={item.title}
                                style={{
                                  maxWidth: 40,
                                  maxHeight: 35,
                                  objectFit: 'contain',
                                }}
                                onError={(e) => {
                                  e.currentTarget.style.display = 'none';
                                  const next = e.currentTarget.nextElementSibling as HTMLElement;
                                  if (next) next.style.display = 'inline-block';
                                }}
                              />
                              <span className={`${item.thumbnail}`} style={{ display: 'none' }}></span>
                            </>
                          );
                        }
                        return <span className={`${item.thumbnail}`}></span>;
                      })()}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ fontWeight: 600, fontSize: '1rem', color: '#1a1a1a' }}>{item.title}</span>
                      {item.subtitle && <span style={{ fontSize: '0.8rem', color: '#8c8c8c' }}>{item.subtitle}</span>}
                    </div>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        ) : null}

        {walletChannels?.length > 0 ? <Typography.Title level={3}>Wallet</Typography.Title> : null}
        <div style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column'
        }}>
          {walletChannels.map((item, index) => {
            return (
              <button
                key={item.code}
                style={{
                  marginBottom: 2,
                  cursor: "pointer",
                  padding: 5,
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  backgroundColor: 'white'
                }}
                onClick={(e) => {
                  e.preventDefault();

                  if (donationDetailCart?.data[0]?.created_by !== "") {
                    let param: PaymentInterfaceParam = {
                      item: item,
                      donationResult: donationDetailCart[0],
                      donationCartResult: donationDetailCart,
                    };

                    history.push({
                      pathname: `/payment-wallet-v2/${encrypt}`,
                      state: param,
                    });
                  } else {
                    openNotification("topRight");
                  }
                }}
              >
                <div style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                  <div style={{
                    paddingLeft: 10,
                    paddingRight: 10
                  }}>
                    <img
                      src={
                        getPaymentImageUrl(item.image_payment, item.thumbnail) ||
                        `https://rustic.universa.vip/images/${item.thumbnail}`
                      }
                      alt={item.title}
                      style={{
                        width: 40,
                        maxHeight: 40,
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        const target = e.currentTarget as HTMLImageElement;
                        if (
                          item.thumbnail &&
                          !target.src.includes(
                            `rustic.universa.vip/images/${item.thumbnail}`
                          )
                        ) {
                          target.src = `https://rustic.universa.vip/images/${item.thumbnail}`;
                        }
                      }}
                    />
                  </div>
                  <span style={{
                    marginLeft: 10,
                    fontSize: '1rem',
                    fontWeight: 'bold'
                  }}>{item.title}</span>
                </div>
                {/* <Card.Meta
                  // avatar={<img src={`/assets/${item.code}.png`} style={{ width: 40, height: 10, objectFit: 'contain' }}/>}
                  avatar={<span className={`${item.thumbnail}`}></span>}
                  title={item.title}
                  description={item.subtitle}
                /> */}
              </button>
            );
          })}
        </div>
      </Spin>
    </div>
  );
}

export default Channel;
